/* Sunrise Atelier — global interactions */
(function () {
  'use strict';

  var doc = document;

  /* ---------- Mobile drawer ---------- */
  var drawer = doc.querySelector('.mobile-drawer');
  var overlay = doc.querySelector('.drawer-overlay');
  function openDrawer() { if (drawer) drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); doc.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); doc.body.style.overflow = ''; }
  doc.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  doc.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* ---------- Mobile submenu toggles ---------- */
  doc.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.nextElementSibling;
      if (sub) sub.classList.toggle('open');
      var sign = btn.querySelector('span');
      if (sign) sign.textContent = sub && sub.classList.contains('open') ? '－' : '＋';
    });
  });

  /* ---------- Accordions ---------- */
  doc.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = trigger.nextElementSibling;
      if (!panel) return;
      var isOpen = panel.style.maxHeight && panel.style.maxHeight !== '0px';
      if (isOpen) { panel.style.maxHeight = '0px'; trigger.setAttribute('aria-expanded', 'false'); }
      else { panel.style.maxHeight = panel.scrollHeight + 'px'; trigger.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ---------- Quantity steppers ---------- */
  doc.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.dataset.dir === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product gallery ---------- */
  var mainImg = doc.querySelector('.product-gallery .main-img img');
  if (mainImg) {
    doc.querySelectorAll('.product-thumbs button').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.dataset.full;
        if (full) mainImg.src = full;
        doc.querySelectorAll('.product-thumbs button').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ---------- Variant selection (updates hidden id + price where possible) ---------- */
  var variantForm = doc.querySelector('#ProductForm');
  if (variantForm) {
    var variantsData = doc.getElementById('variant-json');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    var idInput = variantForm.querySelector('[name="id"]');
    function currentSelections() {
      return Array.prototype.map.call(variantForm.querySelectorAll('.variant-options'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function updateVariant() {
      var sel = currentSelections();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
      if (match && idInput) {
        idInput.value = match.id;
        var btn = variantForm.querySelector('[data-add-btn]');
        if (btn && !btn.dataset.gated) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.dataset.label : (btn.dataset.soldout || 'Sold out');
        }
      }
    }
    variantForm.querySelectorAll('.variant-options input').forEach(function (i) { i.addEventListener('change', updateVariant); });
    updateVariant();
  }

  /* ---------- Sort select auto-submit ---------- */
  var sortSelect = doc.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Facet filters: submit on change, preserve sort, drop page ---------- */
  var facetForm = doc.getElementById('FacetForm');
  if (facetForm) {
    var submitFacets = function () {
      var params = new URLSearchParams();
      var sortEl = doc.querySelector('[data-sort]');
      if (sortEl && sortEl.value) params.set('sort_by', sortEl.value);
      facetForm.querySelectorAll('input[type=checkbox]:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      facetForm.querySelectorAll('input[type=number]').forEach(function (n) {
        if (n.value !== '' && n.name) params.set(n.name, n.value);
      });
      var base = window.location.pathname;
      window.location.href = params.toString() ? base + '?' + params.toString() : base;
    };
    facetForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox]')) submitFacets();
    });
    facetForm.querySelectorAll('input[type=number]').forEach(function (n) {
      n.addEventListener('change', submitFacets);
      n.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitFacets(); } });
    });
    facetForm.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
  }

  /* ---------- Scroll reveal (elegant entrance as sections enter view) ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealSel = '.section-head, .feature-card, .testi-card, .card, .story-copy, .story-media, .stat, .promo-banner__inner, .loc-tile, .cat-tile, .flightmap-panel, .rte, .newsletter, .collection-hero, .loc-card';
  if ('IntersectionObserver' in window && !reduce && !window.MOTION_ACTIVE) {
    doc.documentElement.classList.add('reveal-ready');
    var items = [].slice.call(doc.querySelectorAll(revealSel));
    items.forEach(function (el) { el.classList.add('reveal-item'); });
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.05 });
    items.forEach(function (el) { ro.observe(el); });
  }

  /* ---------- Header: sticky shell + condensed state on scroll ----------
     The sticky must live on the Shopify section wrapper. A sticky element only
     sticks inside its parent's box, and .site-header's parent (div.shopify-section)
     is only as tall as the header itself, so it scrolls straight off. ------------ */
  var header = doc.querySelector('.site-header');
  if (header) {
    var shell = header.closest('.shopify-section') || header.parentElement || header;
    shell.classList.add('header-shell');
    var lastY = -1;
    var onScroll = function () {
      var y = window.scrollY;
      if (y === lastY) return;
      lastY = y;
      if (y > 40) { shell.classList.add('scrolled'); header.classList.add('scrolled'); }
      else { shell.classList.remove('scrolled'); header.classList.remove('scrolled'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
